var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-items-center border d-flex flex-column justify-content-center text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/no-data/No_Available_Data.svg"),"alt":"no data"}})])
}]

export { render, staticRenderFns }